import React from "react";
import { LifeBuoy } from "lucide-react";

const TicketList = React.lazy(() => import("./TicketList"));
const TicketShow = React.lazy(() => import("./TicketShow"));
const TicketCreate = React.lazy(() => import("./TicketCreate"));

export default {
  list: TicketList,
  show: TicketShow,
  create: TicketCreate,
  icon: LifeBuoy,
};
